export default __webpack_public_path__ + "static/media/Elle_Tiffany_2021_04_210929_1.7b2deec6.gif";